export default {
  add_rate: 'Adaugă tarif',
  remove_rate: 'Elimină tariful',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Orice metodă de plată',
    card: 'Card',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Plată prin bancă',
    sepa_debit: 'Debit direct SEPA',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Debit direct Bacs',
    stripe_other: 'Alte metode Stripe',
  },
  fields: {
    percentage: 'Procent',
    fixed: 'Sumă fixă',
    min: 'Sumă minimă',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Pentru {{method}} nu se percepe încă nimic — aceste plăți aduc un marjă de 0% până când se setează un tarif.',
    floor_only:
      'Pentru {{method}}, comisionul de procesare este {{floor}} la fiecare plată, indiferent de totalul comenzii.',
    percentage: 'Pentru {{method}}, comisionul de procesare este {{percentage}}% din totalul comenzii.',
    percentage_floor:
      'Pentru {{method}}, comisionul de procesare este {{percentage}}% din totalul comenzii și cel puțin {{floor}}.',
    fixed: 'Pentru {{method}}, comisionul de procesare este {{fixed}} per plată.',
    fixed_floor: 'Pentru {{method}}, comisionul de procesare este {{fixed}} per plată și cel puțin {{floor}}.',
    combined:
      'Pentru {{method}}, comisionul de procesare este {{fixed}} fix plus {{percentage}}% din totalul comenzii.',
    combined_floor:
      'Pentru {{method}}, comisionul de procesare este {{fixed}} fix plus {{percentage}}% din totalul comenzii și cel puțin {{floor}}.',
    redundant_floor:
      'Minimul de {{floor}} nu se aplică niciodată — suma fixă îl atinge deja la fiecare plată. Setează-l peste {{fixed}} sau șterge-l.',
  },
  example: 'Exemplu: la o comandă de {{total}}, comisionul de procesare este {{fee}}.',
};
